import React from 'react';
import { Alert } from 'antd';

interface IBookstatStatusBannerProps {
  status: 'delayed' | 'error';
  message: string;
}

const BookstatStatusBanner: React.FC<IBookstatStatusBannerProps> = ({ status, message }) => {
  const type = status === 'delayed' ? 'warning' : 'error';

  return (
    <div style={{ position: 'sticky', top: 0, zIndex: 1000 }}>
      <Alert
        banner
        type={type}
        message={
          <div style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            width: '100%',
            position: 'relative'
          }}>
            <span style={{
              display: 'inline-block',
              paddingLeft: '100%',
              animation: 'scroll-text 32s linear infinite'
            }}>
              {message}
            </span>
            <style>
              {`
                @keyframes scroll-text {
                  0% { transform: translateX(0); }
                  100% { transform: translateX(-100%); }
                }
              `}
            </style>
          </div>
        }
        closable
      />
    </div>
  );
};

export default BookstatStatusBanner;
